import axios from 'axios';

// Use localhost for development, production URL for production
export const API_URL = process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'  // Development URL
    : 'https://bus-ecommerce.onrender.com';  // Production URL

const axiosInstance = axios.create({
    baseURL: API_URL,
    withCredentials: true,
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    timeout: 10000,
    validateStatus: function (status) {
        return status >= 200 && status < 500;
    }
});

axiosInstance.interceptors.request.use(
    config => {
        // Add cache-busting for critical data only (bookings need fresh data)
        if (config.method === 'get' && config.url?.includes('/bookings')) {
            config.params = { ...config.params, _t: Date.now() };
        }
        return config;
    },
    error => Promise.reject(error)
);

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.response) {
            if (error.response.status === 401) {
                window.location.href = '/login';
                return Promise.reject(error);
            }
            console.error('API Error Response:', {
                status: error.response.status,
                data: error.response.data,
                headers: error.response.headers
            });
        } else if (error.request) {
            console.error('API Error Request:', error.request);
            if (error.code === 'ERR_NETWORK') {
                console.error('Network error - possible CORS issue');
            }
        } else {
            console.error('API Error:', error.message);
        }
        return Promise.reject(error);
    }
);

export default axiosInstance; 
